import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationPT from "./translation/pt/translation.json";
import translationFR from "./translation/fr/translation.json";
import translationEN from "./translation/en/translation.json"
import translationES from "./translation/es/translation.json"

const fallbackLng = localStorage.getItem("i18nextLng") || "pt"

const availableLanguages = ["pt", "fr", "en", "es"];

const resources = {
  pt: {
    translation: translationPT
  },
  fr: {
    translation: translationFR
  },
  en: {
    translation: translationEN
  },
  es: {
    translation: translationES
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng,

    detection: {
      checkWhitelist: true
    },

    debug: false,

    whitelist: availableLanguages,

    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
